/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import * as es6Promise from "es6-promise";
import "isomorphic-fetch";
es6Promise.polyfill();
//# sourceMappingURL=PolyFill.js.map